import { ITypedReduxAction } from '../../../types/redux/actionType';
import { ICpdRegions } from '../../../types/cpdRegions';

export enum EGetCpdRegionsActionType {
  Succeed = 'cpdRegions/getCpdRegions/succeed',
}

export type TGetCpdRegionsSucceed = ITypedReduxAction<EGetCpdRegionsActionType.Succeed, ICpdRegions>;

export type TGetCpdRegions = TGetCpdRegionsSucceed;
